if (!customElements.get('product-plans')) {
  class customProductOptions extends HTMLElement {
    constructor() {
      super();
      const thisElement = this;
      this.inputRadio = this.querySelectorAll('.radio-input');
      this.planSteps = this.querySelectorAll('.js-plan-steps');
      this.checkNumber = this.querySelector('#check-your-number');
      this.imeiNumberInput = this.querySelector('#imei-number__fields');
      this.checkNumberButton = this.querySelector('#button-check__number');
      this.checkIMEIButton = this.querySelector('#button-check__imei');
      this.buttoTryAgain = this.querySelector('#button-try-again');
      this.continueButton = this.querySelector('.customization-continue__button');
      this.buttonAddToCart = this.querySelectorAll('.button-add-to__cart');
      this.productInfo = this.closest('product-info');
      this.headers = new Headers();
      this.headers.append("hostname", "wrazzle");
      this.headers.append("location", `${window.apiBaseUrl}`);
      this.headers.append("Content-Type", "application/json");
      if(this.productInfo){
        this.planSelectionElement = this.productInfo.querySelectorAll('.addon-plan-selection');
        if(this.planSelectionElement){
          this.planSelectionElement.forEach(function(planElement){
            planElement.addEventListener('change',function(){
              let dataTypes = this.dataset.type;
              thisElement.classList.remove('hidden');
              if(dataTypes == 'yes'){
                thisElement.classList.remove('no-plan');
                thisElement.querySelector('.keep-phone__number').classList.remove('hidden');
                thisElement.querySelector('.customization-continue__button').classList.add('hidden');
              }else{
                thisElement.classList.add('no-plan');
                thisElement.querySelector('.keep-phone__number').classList.add('hidden');
                thisElement.querySelector('.customization-continue__button').classList.remove('hidden');
              }
              thisElement.querySelector('.button-add-to__cart[data-type="with-p-sim"] span').textContent = 'Add to cart';
              thisElement.querySelector('.button-add-to__cart[data-type="add"] span').textContent = 'Add to cart';
            });
          });
        }
      }
      if(this.inputRadio){
        let thisElement = this;
        this.inputRadio.forEach(input => {
          input.addEventListener('change', function() {
            var parentElement = this.closest('.customization-steps');
            var thisValue = this.value;
            var removeSelectedValue = this.getAttribute('data-remove-selected');
            if(removeSelectedValue){
              removeSelectedValue
              thisElement._removeSelected(removeSelectedValue);
            }
            var esimOption = document.querySelector('.product-options[value="eSIM"]');
            var psimOption = document.querySelector('.product-options[value="pSIM"]');
            var simCardTyep = document.getElementById('property-sim-type');
            if(thisValue == 'no-i-want-a-new-number'){
              thisElement.querySelector('#check-your-number').removeAttribute('data-phone-number');
            }
            if (thisValue === 'eSIM' && esimOption) {
              esimOption.checked = true;
              esimOption.dispatchEvent(new Event('change', { bubbles: true }));
              simCardTyep.value = 'esim';
            } else if (thisValue === 'pSIM' && psimOption) {
              psimOption.checked = true;
              psimOption.dispatchEvent(new Event('change', { bubbles: true }));
              simCardTyep.value = 'psim';
            }
            if (thisValue === 'pSIM' || thisValue === 'yes') {
              thisElement.continueButton.classList.remove('hidden');
            }else{
              thisElement.continueButton.classList.add('hidden');
            }
            parentElement.querySelectorAll('.js-plan-steps').forEach(step => {
              var getStepValue = step.getAttribute('data-step');
              if(thisValue == getStepValue){
                step.classList.remove('hidden');
              }else {
                step.classList.add('hidden');
              }
            });
          });
        });
      }
      if(this.checkNumber) {
        this.checkNumber.addEventListener('input', function() {
          thisElement._validateNumber(this.value,this);
        });
      }
      if(this.imeiNumberInput){
        this.imeiNumberInput.addEventListener('input', function() {
          thisElement._validateImeiNumber(this.value,this);
        });
      }
      if(this.checkNumberButton){
        this.checkNumberButton.addEventListener('click', function() {
          var thisValue = thisElement.checkNumber.value;
          thisElement._apiForNumberCheck(thisValue,this);
        });
      }
      if(this.buttoTryAgain){
        this.buttoTryAgain.addEventListener('click', function() {
          thisElement.querySelector('.customization-steps[data-step="not-sure"]').classList.add('hidden');
          thisElement.querySelector('.customization-steps[data-step="not-sure"]').querySelector('.field-error__message').classList.add('hidden');
          thisElement.querySelector('.customization-steps[data-step="not-sure"]').querySelector('.field-success__message').classList.add('hidden');
          thisElement.imeiNumberInput.value = '';
          thisElement.checkIMEIButton.classList.add('disabled-event');
        });
      }
      if(this.buttonAddToCart){
        this.buttonAddToCart.forEach(button => {
          button.addEventListener('click', function() {
            var thisValue = button.dataset.type;
            button.querySelector('.loading__spinner').classList.remove('hidden');
            if(thisValue == 'add'){
              document.querySelector('.product-form__submit').click();
            }else if(thisValue == 'with-p-sim'){
              var psimOption = document.querySelector('.product-options[value="pSIM"]');
              if(psimOption) {
                psimOption.checked = true;
                psimOption.dispatchEvent(new Event('change', { bubbles: true }));
                setTimeout(function(){
                  document.querySelector('.product-form__submit').click();
                },1000);
              }
            }
          });
        });
      }
      if(this.checkIMEIButton){
        this.checkIMEIButton.addEventListener('click', function() {
          var thisValue = thisElement.imeiNumberInput.value;
          thisElement._apiForIMEICheck(thisValue,this);
        });
      }
    }
    _removeSelected(element){
      const jsPlanSteps = this.querySelector('.js-plan-steps[data-step="'+element+'"]').querySelectorAll('.radio-input');
      if (jsPlanSteps) {
        jsPlanSteps.forEach(inputElement => {
          if (inputElement.checked) {
            inputElement.checked = false;
          }
        });
      }
    }
    _validateNumber(inputValue, element){
      var thisValue = inputValue.replace(/\D/g, '');
      var closestElement = element.closest('.keep-phone__number');
      if (thisValue.length > 10) {
        thisValue = thisValue.slice(0, 10);
      }
      let mobileNumber = thisValue;
      if (mobileNumber.length > 3) {
        mobileNumber = mobileNumber.slice(0, 3) + ' ' + mobileNumber.slice(3);
      }
      if (mobileNumber.length > 7) {
        mobileNumber = mobileNumber.slice(0, 7) + ' ' + mobileNumber.slice(7);
      }
      this.checkNumber.value = mobileNumber;
      const mobileNumberPattern = /^[0-9]{3} [0-9]{3} [0-9]{4}$/;
      if (mobileNumberPattern.test(mobileNumber)) {
        element.parentElement.classList.remove('error');
        closestElement.querySelector('.button').classList.remove('disabled-event');
      } else {
        element.parentElement.classList.add('error')
        closestElement.querySelector('.button').classList.add('disabled-event');
      }
    }
    _validateImeiNumber(inputValue, element){
      var thisValue = inputValue.replace(/\D/g, '');
      if (thisValue.length > 15) {
        thisValue = thisValue.slice(0, 15);
      }
      element.value = thisValue;
      var closestElement = element.closest('.customization-steps');
      if(thisValue.length == 15){
        closestElement.querySelector('.button').classList.remove('disabled-event');
      }else {
        closestElement.querySelector('.button').classList.add('disabled-event');
      }
    }
    _apiForNumberCheck(number, thisElement){
      const phoneElement = this.checkNumber;
      const cleanedNumber = number.replace(/\s+/g, '');
      const closestElement = thisElement.closest('.keep-phone__number');
      closestElement.querySelector('.loading__spinner').classList.remove('hidden');
      const raw = JSON.stringify({
        "mdn": cleanedNumber
      });
      const requestOptions = {
        method: "POST",
        headers: this.headers,
        body: raw,
        redirect: "follow"
      };
      fetch(`${window.apiBaseUrl}/api/shopify/pwg/validate-port?isCustomer=true`, requestOptions)
      .then((response) => {
        return response.json();
      })
      .then((result) => {
        console.log(result)
        closestElement.querySelector('.loading__spinner').classList.add('hidden');
        if(result.status == false){
          closestElement.querySelector('.field-error__message').classList.remove('hidden');
          closestElement.querySelector('.error-message__element').textContent = result.message;
          document.querySelector('.customization-steps[data-step="no-i-want-a-new-number"]').classList.add('hidden');
        }else {
          closestElement.querySelector('.field-error__message').classList.add('hidden');
          document.querySelector('.customization-steps[data-step="no-i-want-a-new-number"]').classList.add('hidden');
        }
        if(result[0] && result[0]['description'] == "Eligible"){
          phoneElement.setAttribute('data-phone-number', cleanedNumber);
          closestElement.querySelector('.field-success__message').classList.remove('hidden');
          document.querySelector('.customization-steps[data-step="no-i-want-a-new-number"]').classList.remove('hidden');
        }else{
          closestElement.querySelector('.field-success__message').classList.add('hidden');
          document.querySelector('.customization-steps[data-step="no-i-want-a-new-number"]').classList.add('hidden');
        }
      })
      .catch((error) => console.error(error));
    }
    _apiForIMEICheck(number, thisElement){
      const thisEle = this;
      const cleanedNumber = number.replace(/\s+/g, '');
      const closestElement = thisElement.closest('.customization-steps');
      closestElement.querySelector('.loading__spinner').classList.remove('hidden');
      const requestOptions = {
        method: "GET",
        headers: this.headers,
        redirect: "follow"
      };
      fetch(`${window.apiBaseUrl}/api/shopify/pwg/check-device/` + number, requestOptions)
      .then((response) => {
        return response.json();
      })
      .then((result) => {
        console.log(result)
        closestElement.querySelector('.loading__spinner').classList.add('hidden');
        if(result.status == false){
          closestElement.querySelector('.field-error__message').classList.remove('hidden');
          closestElement.querySelector('.field-success__message').classList.add('hidden');
        }else{
          if(result['data']['ESIM']){
            if(result['data']['ESIM'][0] == "NOT AVAILABLE"){
              closestElement.querySelector('.field-error__message').classList.remove('hidden');
              closestElement.querySelector('.field-success__message').classList.add('hidden');
              thisEle.continueButton.classList.add('hidden');
            } else if(result['data']['ESIM'][0] == "YES"){
              thisEle.continueButton.classList.remove('hidden');
              closestElement.querySelector('.field-error__message').classList.add('hidden');
              closestElement.querySelector('.field-success__message').classList.remove('hidden');
            }
          }
        }
      })
      .catch((error) => console.error(error));
    }
  }
  customElements.define('product-plans', customProductOptions);
}
